import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Search, Plus } from "lucide-react";
import { toast } from "sonner";
import { adminApi } from "@/lib/adminApi";
import { PageHead, when } from "@/studio/ui";
import { AddClientDialog } from "@/studio/AddClientDialog";

export default function Clients() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState("");
  const [clients, setClients] = useState(null);
  const navigate = useNavigate();
  const open = params.get("new") === "1";
  const setOpen = (v) => setParams(v ? { new: "1" } : {}, { replace: true });

  useEffect(() => {
    const t = setTimeout(() => { adminApi.get("/studio/clients", { params: { q } }).then((r) => setClients(r.data)); }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="st-page" data-testid="studio-clients-page">
      <PageHead eyebrow="Clients" title="Client list" lead="Everyone we're designing for, with their projects.">
        <button className="st-btn" onClick={() => setOpen(true)} data-testid="clients-add-button"><Plus size={15} /> Add New Client</button>
      </PageHead>
      <div className="st-toolbar">
        <div className="st-search">
          <Search size={15} />
          <input className="st-input" placeholder="Search by name, email, phone or address" value={q} onChange={(e) => setQ(e.target.value)} data-testid="clients-search-input" />
        </div>
      </div>
      {!clients ? <p className="st-muted">Loading…</p> : clients.length === 0 ? <p className="st-empty" data-testid="clients-empty">No clients match your search.</p> : (
        <table className="st-table" data-testid="clients-table">
          <thead><tr><th>Name</th><th>Contact</th><th>Address</th><th className="st-num">Projects</th><th>Added</th></tr></thead>
          <tbody>
            {clients.map((c) => (
              <tr key={c.id} onClick={() => navigate(`/admin/studio/clients/${c.id}`)} data-testid={`client-row-${c.id}`}>
                <td style={{ fontWeight: 600 }}>{c.full_name}</td>
                <td data-label="Contact"><div>{c.email}</div><div className="st-muted st-small">{c.phone}</div></td>
                <td data-label="Address" className="st-muted">{c.address || "—"}</td>
                <td data-label="Projects" className="st-num">{c.projects_count}</td>
                <td data-label="Added" className="st-muted st-small">{when(c.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <AddClientDialog open={open} onOpenChange={setOpen} onCreated={(c) => { toast.success(`${c.full_name} added`); navigate(`/admin/studio/clients/${c.id}`); }} />
    </div>
  );
}
